<template>
  <el-dialog :visible="visible" @close="close" fullscreen :close-on-click-modal="false" :close-on-press-escape="false"
    append-to-body class="editor" v-loading="meta.loading" :show-close="false">
    <el-row v-if="record" slot="title" type="flex" align="middle" style="margin-top: -5px">
      <template v-if="!isEmbed">
        <small class="left-pad">患者：</small>
        <el-link type="primary" class="sub-title" @click="meta.showTreats = true" title="点击切换患者...">
          <b>{{ record.patientName }}</b>
        </el-link>
        <small class="left-pad">{{ record.opNo ? "门诊" : "住院" }}号：</small>
        <el-link :type="!readonly ? 'primary' : 'info'" class="sub-title" @click="
          help.active = 'his';
        help.show = true;
        " title="点击切换既往病历...">
          {{ record.opNo || record.ipNo }}
        </el-link>
        <span class="left-pad info" title="首诊医生">
          {{ record.deptCode | dictText("Dept") }}
          {{ record.doctorName }}
        </span>
      </template>
      <small class="left-pad">文书：</small>
      <el-popover v-if="mr.curr" placement="bottom-start" trigger="hover">
        <p v-for="item in mr.items" :key="item.id">
          <el-link class="sub-title left-pad" @click="mrChange(item)" :disabled="mr.curr && mr.curr.id == item.id"
            icon="el-icon-document">{{ item.tmplCode | dictText("MrTemplate") }}</el-link>
          <small v-if="item.editingUserCode" title="编辑中！已锁定！" class="left-pad"><i class="el-icon-edit" /> {{
            item.editingUserName }}</small>
          <el-button v-if="!readonly && item.doctorCode == user.code" type="primary" class="el-icon-delete left-pad"
            size="mini" plain circle @click="mrDel(item)" />
        </p>
        <el-link slot="reference" :type="addable ? 'primary' : 'info'" class="sub-title"
          @click="addable && addMrBySetting()" title="点击追加文书...">
          {{ mr.curr.tmplCode | dictText("MrTemplate") }}
        </el-link>
      </el-popover>
      <el-link v-else-if="!mr.items.length && addable" type="primary" class="sub-title" @click="addMrBySetting()">
        <span>点我添加文书</span>
      </el-link>
      <el-link v-else type="info" class="sub-title">
        <span>当前病历中不含文书</span>
      </el-link>
      <el-tag :type="editable ? 'success' : 'danger'" effect="plain" class="left-pad">
        {{ editable ? "编辑" : "只读" }}
      </el-tag>
      <small v-if="meta.warning" class="left-pad danger">{{ meta.warning }}</small>
      <span v-if="meta.dataExtracting" class="left-pad success"> 正在抽取HIS数据 <i class="el-icon-loading" /></span>
    </el-row>
    <el-row v-if="!record" class="f-h" type="flex" justify="center" align="middle">
      <el-button type="primary" @click="meta.showTreats = true" icon="el-icon-user" size="small"
        class="f-w sub-title">请选择下一份病历！</el-button>
    </el-row>
    <el-container v-show="record">
      <el-main class="f-h">
        <Ide ref="ide" />
      </el-main>
      <el-aside v-show="help.show" width="50%" class="f-h">
        <el-container>
          <el-header>
            <el-tabs stretch v-model="help.active" type="card">
              <el-tab-pane v-if="!readonly" name="input" class="f-h">
                <span slot="label"><i class="el-icon-magic-stick" /> 辅助 </span>
              </el-tab-pane>
              <el-tab-pane name="his">
                <span slot="label"><i class="el-icon-folder-checked" /> 既往 </span>
              </el-tab-pane>
              <el-tab-pane name="ver">
                <span slot="label"><i class="el-icon-document-checked" /> 版本 </span>
              </el-tab-pane>
              <el-tab-pane name="output">
                <span slot="label"><i class="el-icon-toilet-paper" /> 输出 </span>
              </el-tab-pane>
              <el-tab-pane name="collection">
                <span slot="label"><i class="el-icon-document" /> 收藏 </span>
              </el-tab-pane>
            </el-tabs>
          </el-header>
          <el-main style="position: absolute; top: 60px; bottom: 0px; left: 50%; right: 0">
            <HelpInput ref="input" v-show="help.active == 'input'" :tmpl="currTmpl" />
            <HelpOutput v-show="help.active == 'output'" :readonly="readonly" @refresh="$refs.ide.genStruct()" />
            <HelpVer v-show="help.active == 'ver'" ref="helpVer" :mr="mr.curr" />
            <!--既往病历，展示病历-->
            <HelpHis v-show="help.active == 'his'" :main="main" @relate="relate" @apply="apply" />
            <HelpCollection v-show="help.active == 'collection'" :main="main" @relate="relate" />
          </el-main>
        </el-container>
      </el-aside>
    </el-container>
    <template slot="footer">
      <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; height: 100%">
        <div>
          <el-button-group>
            <!-- <el-button type="primary" icon="el-icon-full-screen" @click="$refs.ide.resize()"></el-button> -->
            <el-dropdown split-button type="primary" size="small" @click="$refs.ide.print()"
              @command="$refs.ide.download" v-if="permission.emr_mr_print && record && mr.curr" title="打印...">
              <i class="el-icon-printer"> 打印</i>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-document" command="docx">word文档</el-dropdown-item>
                <el-dropdown-item icon="el-icon-document" command="pdf">pdf文档</el-dropdown-item>
                <el-dropdown-item icon="el-icon-document" command="html">html文档</el-dropdown-item>
                <el-dropdown-item icon="el-icon-document" command="bin">bin文档</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-button-group>
          <el-button-group v-if="record" class="left-pad">

            <el-button v-if="editable" type="primary" size="small" icon="el-icon-refresh"
              @click="$refs.ide.refreshMeta()" :loading="meta.loading" title="刷新">刷新</el-button>
            <el-button v-if="editable && currTmpl?.ifRepeatable" type="primary" size="small" icon="el-icon-plus"
              @click="insertTemplate()" title="新增">新增</el-button>
            <el-button type="warning" size="small" :icon="help.show ? 'el-icon-folder-opened' : 'el-icon-folder'"
              @click="help.show = !help.show" title="辅助...">辅助</el-button>
          </el-button-group>
        </div>
        <div style="display: flex; justify-content: flex-end; align-items: center">
          <el-image v-if="editable && !signature.valid && user.defaultImg" :src="user.defaultImg" @load="imgLoaded"
            fit="fill" style="height: 2rem; width: 4rem" />
          <el-button type="text" v-if="editable && !signature.valid" @click="$refs.ide.insertName()" class="left-pad">
            插入医生姓名</el-button>
          <el-button type="text" v-if="editable && !signature.valid" @click="signature.showDlg = true" class="left-pad">
            数字签名证书选择！</el-button>
          <el-button v-if="editable && signature.valid" type="warning" @click="insertImg()" class="left-pad">插
            入</el-button>
          <el-image v-if="editable && signature.valid && signature.imgSrc"
            :src="`data:image/jpg;base64,${signature.imgSrc}`" class="left-pad" style="height: 2rem; width: 4rem"
            @load="imgLoaded" />
          <template v-if="!isEmbed">
            <el-button type="info" size="small" @click="$emit('update:visible', false)" class="left-pad">关 闭</el-button>
            <el-button type="primary" size="small" @click="save()" v-if="editable && editable && !setting.isSimple"
              :loading="meta.saving">暂 存</el-button>
            <el-button type="success" size="small" @click="save(true)" v-if="editable" :loading="meta.saving">提
              交</el-button>
          </template>
          <template v-else>
            <el-button type="primary" size="small" @click="save()" v-if="editable && editable && !setting.isSimple"
              :loading="meta.saving">保 存</el-button>
            <el-button type="primary" size="small" @click="save(true)" v-if="editable && editable && setting.isSimple"
              :loading="meta.saving">保 存</el-button>
          </template>
        </div>
      </div>
    </template>

    <!--北京CA电子证书-->
    <DlgUKey v-if="signature.au == 'bjcaUkey'" :visible.sync="signature.showDlg" @ok="signSelected" />
    <!--就诊记录，切换患者-->
    <DrawerTreat :visible.sync="meta.showTreats" :entities="entities" :condition="condition" :record="record"
      @paging="$emit('paging')" @refreshing="$emit('refreshing')" @ok="entitySwitch" />

    <!--模板列表，追加文书-->
    <DrawerTmpl :visible.sync="meta.showTmpl" :record="record" :mrs="mr.items" @ok="mrAdd" />
  </el-dialog>
</template>

<script>
import { mapGetters } from "sw-hic";
import jwtDecode from "jwt-decode";
export default {
  props: {
    visible: Boolean,
    main: Object, // 上级传入的病历
    readonly: Boolean, // 只读模式
    entities: Object, // 就诊记录列表
    condition: Object, // 就诊查询条件
    isEmbed: Boolean, // 是否嵌入模式
  },
  components: {
    DlgUKey: () => import("./dlgUKey.vue"),
    DrawerTreat: () => import("./_drawerTreat.vue"),
    DrawerTmpl: () => import("./_drawerTmpl.vue"),
    Ide: () => import("./_ide.vue"),
    HelpInput: () => import("./_helpInput.vue"),
    HelpOutput: () => import("./_helpOutput.vue"),
    HelpVer: () => import("./_helpVer.vue"),
    HelpHis: () => import("./_helpHis.vue"),
    HelpCollection: () => import("./_helpCollection.vue"),
  },

  data() {
    return {
      signRatio: 0, // 签名图片高宽比
      meta: {
        loading: false,
        saving: false,
        closing: false,
        showTreats: false,
        showTmpl: false,
        dataExtracting: false,
        warning: false,
      },
      record: null, // 当前病历
      mr: {
        // 文书
        items: [],
        curr: null,
        locked: true,
      },
      help: {
        active: "input",
        show: false,
      },
      signature: {
        valid: true,
        certs: [],
        certId: null,
        cert: null,
        pwd: null,
        need: true,
        imgSrc: null,
        showDlg: false,
      },
    };
  },
  computed: {
    ...mapGetters(["Enum", "dict", "user", "permission", "token", "setting"]),
    currTmpl() {
      // 当前文书模板
      if (!this.mr.curr) {
        return null;
      }
      return this.dict.MrTemplate.find((tm) => tm.code == this.mr.curr.tmplCode);
    },
    editable() {
      return !this.readonly && this.mr.locked;
    },
    addable() {
      return !this.readonly && (!this.setting.onlyAllowOwnerAdd || this.main.doctorCode == this.user.code);
    },
    deptCodes() {
      // 获取当前科室及上级科室的编码数组
      let deptCodes = [this.user.deptCode];
      let dept = this.dict.Dept.find((d) => d.code == this.user.deptCode);
      if (dept) {
        dept.codeChain.split("@").forEach((d) => {
          if (d && deptCodes.findIndex((c) => c == d) == -1) {
            deptCodes.push(d);
          }
        });
      }
      return deptCodes;
    },
    validtmpls() {
      let items = this.$utils.Obj.clone((this.dict.MrTemplate || []).filter((t) => !t.disabled && (!t.deptCode || this.deptCodes.findIndex((d) => t.deptCode == d) != -1)));

      if (!this.main.patientGender) {
        return items;
      } else {
        let gender = this.$utils.Dict.text(this.main.patientGender, "Gender");
        if (gender.indexOf("男") >= 0) {
          return items.filter((t) => t.gender == this.Enum.MrGender.男 || t.gender == this.Enum.MrGender.不限);
        }
        if (gender.indexOf("女") >= 0) {
          return items.filter((t) => t.gender == this.Enum.MrGender.女 || t.gender == this.Enum.MrGender.不限);
        }
        return items;
      }
    },
    mrGender() {
      if (!this.main.patientGender) {
        return this.Enum.MrGender.不限;
      } else {
        let gender = this.$utils.Dict.text(this.main.patientGender, "Gender");
        if (gender.indexOf("男") >= 0) {
          return this.Enum.MrGender.男;
        }
        if (gender.indexOf("女") >= 0) {
          return this.Enum.MrGender.女;
        }
        return this.Enum.MrGender.不限;
      }
    },
  },
  watch: {
    main() {
      this.open();
    },
  },
  created() {
    this.initSignature();
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.open();
    // });
  },
  methods: {
    initSignature() {
      const { userInfo } = jwtDecode(this.token);
      if (!userInfo.certId) {
        this.signature.valid = false;
        this.signature.au = "bjcaUkey";
      } else {
        this.signature.certId = userInfo.certId;
        this.signature.au = this.user.au;
        if (this.signature.au == "bjcaUkey") {
          GetSignCert(
            this.signature.certId,
            (res) => {
              this.signature.cert = res.retVal;
            },
            {}
          );
          GetPic(
            this.signature.certId,
            (res) => {
              this.signature.imgSrc = res.retVal;
            },
            {}
          );
        }
      }
    },
    open() {
      if (this.readonly) {
        this.help.active = "his";
      } else if (!this.readonly) {
        this.help.active = "input";
      }
      Object.keys(this.meta).forEach((k) => {
        this.meta[k] = false;
      });
      this.meta.showTmpl = false;
      this.help.show = false;
      this.mr = {
        items: [],
        curr: null,
        locked: true,
      };
      this.record = null;
      this.load();
    },
    async addMrBySetting() {
      if ("true" == this.setting.onlyAllowSelfAdd && this.mr.items.length != 0 && this.mr.curr.doctorCode != this.user.code) {
        this.$message("不允许除" + this.mr.curr.doctorName + "以外的医生在此份病历中新建文书!");
        this.meta.showTmpl = false;
        return;
      }
      this.meta.showTmpl = true;
    },
    async load() {
      if (!this.record) {
        if (!this.main?.id) {
          if (this.$ide) this.$ide.closeFile();
          return;
        }
        this.record = this.main;
      }
      this.$utils.log(`当前病历：`, this.record);

      this.mr.items = (await this.$api.Mr.query({ mainId: this.record.id })).items;
      this.$utils.log(`加载病历${this.record.id}所有文书：`, this.mr.items);
      if (this.mr.items.length) {
        this.$utils.log(`找到第一个文书Id：${this.mr.items[0].id}`, this.mr.items[0]);
        this.mrChange(this.mr.items[0]);
      } else {
        this.$utils.log(`没找到文书`);
        if ("true" == this.setting.autoCreate && !this.readonly && this.validtmpls.length > 0) {
          this.$utils.log(`找到第一个模板`, this.validtmpls[0]);
          this.mrAdd(this.validtmpls[0]);
        } else {
          this.$refs.ide.closeFile();
        }
      }
    },
    async mrChange(mr) {
      if (this.mr.curr && !this.readonly) {
        try {
          await this.$refs.ide.save();
        } catch (err) {
          console.log(err);
        }
      }
      if (this.$refs.ide) {
        this.$refs.ide.closeFile();
      }
      this.meta.warning = "";
      this.mr.curr = mr;
      this.mr.locked = false;
      if (!this.readonly) {
        try {
          this.$utils.log(`尝试锁定文书${mr.id}`);
          this.mr.curr = await this.$api.Mr.lock(mr.id);
          this.mr.locked = true;
        } catch (err) {
          console.log(err);
          this.meta.warning += err;
        }
      }
      this.mrOpen();
    },
    async mrOpen() {
      if (this.readonly || !this.mr.locked) {
        // 浏览模式或者编辑模式但是加锁失败
        let ver = await this.$api.MrVer.view(this.mr.curr.id);
        if (!ver) {
          this.meta.warning += "没有正式版！";
          return;
        }
        // this.$refs.ide.openFile(ver.content, false);
        this.$refs.ide.open(ver, this.mr.curr, this.record, this.currTmpl, false);
        if (ver.ifEditing) {
          this.meta.warning += "只有草稿！";
        }
        return;
      }
      // 编辑模式并且成功加锁
      let ver = await this.$api.MrVer.edit(this.mr.curr.id);
      this.$refs.ide.open(ver, this.mr.curr, this.record, this.currTmpl, true);
    },
    async mrAdd(tmpl) {
      tmpl = await this.$api.Tmpl.get(tmpl.id); // 刷新模板
      this.$utils.log(`准备追加文书，模板为：`, tmpl);
      if (tmpl) {
        try {
          if (tmpl.gender != this.Enum.MrGender.无限) {
            // TODO 性别字典还需要对应，暂不 check
          }
          if (!tmpl.ifRepeatable && this.mr.items.findIndex((mr) => mr.tmplCode == tmpl.code) >= 0) {
            throw `当前模板对应文书不允许重复，且病历中已经有此模板对应的文书，追加失败！`;
          }
          // if (!tmpl.ver) {
          //   throw `模板没有正式版本，追加失败！`;
          // }
          let mrEntity = {
            tmplCode: tmpl.code,
            deptCode: this.record.deptCode,
            patientCode: this.record.patientCode,
            patientName: this.record.patientName,
            patientGender: this.record.patientGender,
            patientAge: this.record.patientAge,
            mrDate: this.$utils.Dt.now(),
            doctorCode: this.user.code,
            doctorName: this.user.name,
            mainId: this.record.id,
            qcState: this.Enum.MrQCState.未提交,
            opNo: this.main.opNo || this.main.ipNo,
          };
          this.$utils.log("准备追加文书：", mrEntity);
          mrEntity = await this.$api.Mr.save(mrEntity);
          this.$utils.log("追加成功", mrEntity);
          this.mr.items.push(mrEntity);
          this.mrChange(mrEntity);
        } catch (error) {
          if (error != "编辑器未加载文件") this.$message.error(error);
        }
      }
      this.meta.showTmpl = false;
    },
    async mrDel(mr) {
      try {
        await this.$confirm("确定要删除当前文书吗？", "删除确认");
        await this.$api.Mr.del(mr.id);
        this.mr.items.splice(this.mr.items.indexOf(mr), 1);

        if (this.mr.curr && this.mr.curr.id == mr.id) {
          if (this.mr.items.length) {
            this.mrChange(this.mr.items[0]);
          } else {
            this.mr.curr = null;
            this.mr.locked = false;
            this.$refs.ide.closeFile();
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async close() {
      if (this.meta.closing) {
        return;
      } else {
        this.meta.closing = true;
      }
      try {
        await this.save();
      } catch (error) {
        console.log(error);
      } finally {
        this.meta.closing = false;
      }
      // 改为关闭就解锁
      if (this.record) {
        await this.$api.MrMain.unlock(this.record.id);
      }
      this.$refs.ide.closeFile();

      // 下次打开IDE需要重新初始化
      this.$refs.ide.meta.inited = false;
      this.$refs.ide.meta.opened = false;
      this.$refs.helpVer.unInit();

      this.$emit("close");
      this.$emit("update:visible", false);
    },

    async save(isSubmit) {
      this.$utils.log("提交", isSubmit);
      if (this.readonly || this.meta.saving) {
        return;
      }

      this.meta.saving = true;
      try {
        if (this.mr.curr && this.mr.locked) {
          await this.$refs.ide.save(isSubmit);
        }

        this.$emit("saved");
      } catch (err) {
        if (err && err != "未修改") {
          this.$message.error(err?.message || err);
        }
      } finally {
        this.meta.saving = false;
      }
      if (isSubmit) {
        await this.$api.MrMain.submit(this.record.id);
        // 发送给HIS, 内容参数穿空字符串后端会自动重新获取
        this.$api.MrMain.send(this.record.id, "");
        if (this.signature.need && this.signature.valid) {
          let signed = await this.sign();
          if (!signed) {
            this.$message.warning("数字签名失败！");
            return;
          } else {
            this.$message.success("已数字签名！");
          }
        }
        this.$nextTick(() => {
          this.$message.success("病历已提交！");
          this.$emit("submited");
        });
        if (!this.isEmbed) {
          if (this.setting.isSimple) {
            this.mrOpen();
          } else {
            this.entitySwitch();
          }
        }
      }
    },

    async relate(record) {
      try {
        await this.$confirm(`使用右侧既存病历作为当前门诊记录的病历（左侧编辑中病历将被覆盖）确定吗？`, "连续病历");
        let taget = await this.$api.MrMain.lock(record.id);
        this.main = await this.$api.MrMain.relate(taget.id, this.main.opNo);
        this.record = this.main;
        this.load();
      } catch (error) {
        if (error != "cancel") {
          this.$message.warning(error);
        }
      }
    },
    insertImg() {
      this.$refs.ide.insertImg(this.signature.imgSrc);
    },
    async sign() {
      let ps = [];
      let md5s = await this.$api.MrMain.md5(this.main.id);
      this.$utils.log("取得需要签名的MD5：");
      this.$utils.log(md5s);
      if (!md5s || !md5s.length) {
        return true;
      }
      md5s.forEach((md5) => {
        ps.push(
          new Promise((resolve, reject) => {
            SignedData(
              this.signature.certId,
              md5,
              (res) => {
                if (res.retVal) {
                  resolve({ md5: md5, sign: res.retVal });
                } else {
                  this.$utils.log("北京CA的JS签名方法报错：");
                  this.$utils.log(res);
                  reject("签名失败！");
                }
              },
              {}
            );
          })
        );
      });
      if (ps.length) {
        try {
          let signs = await Promise.all(ps);
          await this.$api.Mr.sign({
            userCertAu: this.signature.au,
            userCertId: this.signature.certId,
            userCert: this.signature.cert,
            md5Signs: signs,
          });
          await this.$api.Oidc.update({
            auCode: this.signature.au,
            openId: this.user.openId,
            signImage: this.signature.imgSrc,
          });
          return true;
        } catch (err) {
          this.$utils.log("北京CA签名后，更新数据库时报错");
          console.log(err);
        }
      }
      return false;
    },
    async signSelected(certId) {
      let _this = this;
      this.signature.certId = certId;
      let au = this.signature.au;
      this.user.au = this.signature.au;
      this.$utils.log(`证书ID：${certId}`);
      // 通过证书ID获取证书
      GetSignCert(
        this.signature.certId,
        (res) => {
          _this.signature.cert = res.retVal;
          _this.$utils.log(`证书：${_this.signature.cert}`);

          // 通过证书获取唯一识别码
          GetExtCertInfoByOID(
            _this.signature.cert,
            "1.2.156.112562.2.1.1.1",
            (res) => {
              _this.$utils.log(`唯一识别码：`);
              _this.$utils.log(res);
              _this.user.openId = res.retVal.substring(2);
              // 通过唯一识别码获取用户
              this.$api.Oidc.get(au, _this.user.openId)
                .then((res) => {
                  if ((res.id = this.user.id)) {
                    _this.$store.commit("user", this.user);

                    GetPic(
                      _this.signature.certswitchMainId,
                      (res) => {
                        _this.signature.imgSrc = res.retVal;
                      },
                      {}
                    );
                    _this.signature.valid = true;
                  } else {
                    _this.signature.certId = null;
                    _this.signature.cert = null;

                    _this.signature.valid = false;
                    _this.signature.need = false;
                    _this.$message.error("选择的证书与当前登录用户不匹配！");
                  }
                })
                .catch((err) => {
                  console.log(`查找用户失败，${err}`);
                });
            },
            {}
          );
        },
        {}
      );
    },
    entitySwitch(row) {
      if (this.record && row?.mrMain?.id == this.record.id) {
        return;
      }

      this.meta.showTreats = false;

      if (row) {
        if (this.mr.curr && this.editable) {
          this.save().then(() => {
            this.$emit("entitySwitch", row);
          });
        } else {
          this.$emit("entitySwitch", row);
        }
      } else {
        this.$emit("entitySwitch");
        this.$nextTick(() => {
          this.meta.showTreats = true;
        });
      }
    },
    dataExtract(being) {
      this.meta.dataExtracting = being;
    },
    imgLoaded(e) {
      if (e.target.width && e.target.height) {
        this.signRatio = e.target.height / e.target.width;
      }
    },
    getIdeSelectText() {
      return this.$refs.ide.getSelectedText();
    },
    unlock() {
      if (!this.record) {
        return;
      }
      this.$api.MrMain.unlock(this.record.id);
    },
    apply(txt) {
      this.$refs.ide.apply(txt)
    },
    async insertTemplate() {
      // 获取当前模板最新版本
      const ver = await this.$api.TmplVer.view(this.currTmpl.id)
      this.$refs.ide.applyFile(ver.content)
    }
  },
};
</script>
<style scoped>
/deep/.el-dialog__body {
  height: unset;
}

/deep/.el-dialog__footer {
  height: 70px;
  padding: 0px 15px 5px 15px;
}
</style>
